import React, { useEffect, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useAngularService } from 'helpers/get_angular_service';

interface RecaptchaProps {
  recaptchaKey: string;
  onSuccess: (token: string) => void;
  onError: () => void;
}

const Recaptcha = ({ recaptchaKey, onSuccess, onError }: RecaptchaProps) => {
  const ref = useRef<any>();
  const $rootScope = useAngularService('$rootScope');

  useEffect(() => {
    const unsubscribe = $rootScope.$on('recaptcha:execute', () => {
      if (ref && ref.current) {
        ref.current.execute();
      }
    });
    return unsubscribe;
  }, [$rootScope]);

  return (
    <div>
      <ReCAPTCHA
        ref={ref}
        size="invisible"
        sitekey={recaptchaKey}
        onChange={(token) => {
          onSuccess(token);
          ref.current.reset();
        }}
        onErrored={onError}
      />
    </div>
  );
};

export default Recaptcha;
